export default __webpack_public_path__ + "static/media/le_croise8.53be6a2e.jpg";